declare global {
  interface Window {
    _agl: unknown[];
  }
}

export const loadBaiduTracking = () => {
  if (document.querySelector('script[data-baidu-agl]')) {
    return;
  }

  window._agl = window._agl || [];
  window._agl.push(['production', '_f7L2XwGXjyszb4d1e2oxPybgD']);

  const agl = document.createElement('script');
  agl.type = 'text/javascript';
  agl.async = true;
  agl.setAttribute('data-baidu-agl', 'true');
  agl.src = 'https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD';
  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(agl, firstScript);
  } else {
    document.head.appendChild(agl);
  }
};
